export default __webpack_public_path__ + "static/media/040_tunnel.last.4198bda4.webp";